import { z } from 'zod';

export const requiredErrorMessage = 'error.required';

export const requiredField = z
  .string()
  .transform((value) => value.trim()) // we make sure we don't allow only space characters
  .pipe(z.string().min(1, { message: requiredErrorMessage }));
